import React,{useEffect, useState, useContext} from 'react';
import { GlobalContext } from '../../Contexts/GlobalContext';
import useFetch from 'CustomHooks/useFetch';

export default function useCustomerServicePreferences (props) {
    const globalContext = useContext(GlobalContext);
    const [getCustomerServicePreferencesHookResponse, getCustomerServicePreferencesHook] = useFetch();
    const [postCustomerServicePreferencesHookResponse, postCustomerServicePreferencesHook] = useFetch();
    

    useEffect(
        () => {
            getCustomerServicePreferencesHook(
                {
                    url: '/admin/CustomerServicePreferences',
                    method: 'GET',
                    addTokenHeader: true,
                }
            )
        }, []
    )

    const updateCustomerServicePreferences = (options) => {
        postCustomerServicePreferencesHook(
            {
                url: '/admin/CustomerServicePreferences',
                method: 'POST',
                addTokenHeader: true,
                postData: {...options},
            }
        )
    }

    return [getCustomerServicePreferencesHookResponse,
        updateCustomerServicePreferences, 
        postCustomerServicePreferencesHookResponse];
}
